import KeyMirror from 'keymirror'
import { tenancyType } from '@/utils/locale'

export const TENANCY_HISTORY_TYPE = KeyMirror({
  LIFECYCLE: null,
})

export const HISTORY_SOURCE_TABLE = {
  TENANCIES: 'tenancies',
  CCD_CONTACTS: 'ccd_contacts',
}

export const FIRE_MARSHAL_ROLE = KeyMirror({
  PRIMARY: null,
  DEPUTY: null,
})

// Use on the link logic of ccd contact page
// On the all contacts table of all contacts tab of TR detail page
// On the `addTenancyContactsToStore` method that is storing linked contact
// Note: Please go to hint.json file to update i18n keys(linkedEmailContactNames, linkedPhoneContactNames, hintEmptyContactWarn) if any change made here
export const TENANCY_ALL_CONTACT_TYPES = ['isCircular', 'isEmergency', 'isOthers', 'isMarketing', 'isFireMarshal']
export const CCD_EMAIL_LINK_TENANCY_TYPES = ['isCircular', 'isMarketing', 'isFireMarshal']
export const CCD_PHONE_LINK_TENANCY_TYPES = ['isEmergency', 'isMarketing', 'isFireMarshal']
export const TENANCY_ALL_CONTACT_TYPES_MAP = {
  isCircular: 'cEmails',
  isMarketing: 'mEmails',
  isFireMarshal: 'fEmails', // @TODO to be confirm
}
export const CCD_TENANCY_CONTACT_TYPES_MAP = {
  'isCircular': {
    i18nKey: 'ecircular',
  },
  'isEmergency': {
    i18nKey: 'emergency',
  },
  'isFireMarshal': {
    i18nKey: 'fireMarshal',
  },
  'isMarketing': {
    i18nKey: 'marketing',
  },
}
// Warning map for tenancy all contact tab empty check
export const TR_EMPTY_CONTACT_WARN_MAP = {
  [tenancyType.Retail]: Object.keys(CCD_TENANCY_CONTACT_TYPES_MAP),
  [tenancyType.Office]: Object.keys(CCD_TENANCY_CONTACT_TYPES_MAP).filter(type => type !== 'isMarketing'),
}
